import { defineStyle } from '@chakra-ui/styled-system'
import { mode } from '@chakra-ui/theme-tools'

const accessibleColorMap = {
  yellow: {
    bg: 'yellow.400',
    color: 'black',
    hoverBg: 'yellow.500',
    activeBg: 'yellow.600'
  },
  cyan: {
    bg: 'cyan.400',
    color: 'black',
    hoverBg: 'cyan.500',
    activeBg: 'cyan.600'
  }
}

const variantSolid = defineStyle((props) => {
  const { colorScheme: c } = props

  if (c === 'gray') {
    const bg = mode('gray.200', 'whiteAlpha.200')(props)

    return {
      bg,
      color: mode('gray.800', 'whiteAlpha.900')(props),
      _hover: {
        bg: mode('gray.300', 'whiteAlpha.300')(props),
        _disabled: {
          bg
        }
      },
      _active: { bg: mode('gray.400', 'whiteAlpha.400')(props) }
    }
  }

  const {
    bg = `${c}.500`,
    color = 'white',
    hoverBg = `${c}.600`,
    activeBg = `${c}.700`
  } = accessibleColorMap[c] ?? {}

  const background = mode(bg, `${c}.200`)(props)

  return {
    bg: background,
    color: mode(color, 'gray.800')(props),
    _hover: {
      bg: mode(hoverBg, `${c}.300`)(props),
      _disabled: {
        bg: background
      }
    },
    _active: { bg: mode(activeBg, `${c}.400`)(props) }
  }
})

export const buttonTheme = {
  colorScheme: {
    gray: {
      bg: 'gray.300',
      _hover: {
        bg: 'gray.400'
      }
    }
  },
  variants: {
    solid: variantSolid
  }
}
